module.exports = __webpack_public_path__ + "532e70b17da0caf33e767c42e679f719.svg";